import { AlertColor } from '@mui/material'
import React from 'react'

// Optional action button rendered inside the snackbar (e.g. "Retry" on a
// 5xx burn error). Clicking the button closes the snackbar before
// invoking `onClick`, so callers don't need to dismiss explicitly.
export type SnackbarAction = {
  label: string
  onClick: () => void
}

export type SnackbarState = {
  isOpen: boolean
  message: string
  dismissDuration?: number
  severity?: AlertColor
  action?: SnackbarAction
}

export type SnackbarContextType = {
  snackbar: SnackbarState
  openSnackbar: (
    message: string,
    dismissDuration?: number,
    severity?: AlertColor,
    action?: SnackbarAction
  ) => void
  closeSnackbar: () => void
}

export const SnackbarContext = React.createContext<
  SnackbarContextType | undefined
>(undefined)
